import {BaseDialogViewModel} from "../common/BaseDialogViewModel";
import {BadRequestError} from "../../../tracejs/src/application/BadRequestError";
import {Tracedo} from "../../entities/Tracedo";
import {Checkpoint} from "../../entities/Checkpoint";
import {i18n} from "i18next-ko";
import moment from "moment/moment";
import {h} from "../../../tracejs/src/utils/JSXFactory";
import {injectable} from "tsyringe";

@injectable()
export class TrainArrivalDialog extends BaseDialogViewModel<any> {

    private ata: KnockoutObservable<Date>;
    private eta: KnockoutObservable<Date>;

    async startup(): Promise<any> {
        await super.startup();

        if (!this.user.isAllowed('entity.tracedo', 'approve')) {
            throw new BadRequestError('Access denied', 403);
        }

        let tracedo: Tracedo = await this.rpc.call('tracedo.getOne', { id: this.settings.tracedoId, query: { select: "id, railUnloadId, checkpoints(*, ramp(*))"} });
        if (!tracedo.railUnloadId) {
            throw new BadRequestError('Not Found', 404);
        }

        let railUnloadCheckpoint: Checkpoint = tracedo.checkpoints.filter((checkpoint: Checkpoint): boolean => checkpoint.id == tracedo.railUnloadId)[0];
        this.ata = ko.observable(railUnloadCheckpoint.ata ? kendo.parseDate(railUnloadCheckpoint.ata as string) : null);
        this.eta = ko.observable(railUnloadCheckpoint.eta ? kendo.parseDate(railUnloadCheckpoint.eta as string) : null);
    }

    public async save(): Promise<boolean> {
        const ata = this.ata()
        const eta = this.eta()
        const ataString = ata === null ? null : moment(ata).format();
        const etaString = eta === null ? null : moment(eta).format();

        await this.rpc.call('tracedo.setTrainArrival', { id: this.settings.tracedoId, ata: ataString, eta: etaString });
        return true;
    }

    public dialogTemplate = (): HTMLElement => (
        <div>
            <div className="row mb-2">
                <label className="inline col-md-2 col-form-label"
                       data-bind="uniqueFor: 'trainArrivalEta', i18n: 'common.captions.eta'"></label>
                <div className="col-md-10">
                    <input type="text" className="form-control"
                           data-bind="kendoDateTimePicker: { value: eta, animation: false }, uniqueId: 'trainArrivalEta'"/>
                </div>
            </div>
            <div className="row mb-2">
                <label className="inline col-md-2 col-form-label"
                       data-bind="uniqueFor: 'trainArrivalAta', i18n: 'common.captions.ata'"></label>
                <div className="col-md-10">
                    <input type="text" className="form-control"
                           data-bind="kendoDateTimePicker: { value: ata, animation: false }, uniqueId: 'trainArrivalAta'"/>
                </div>
            </div>
        </div>
    )
}